(function () {
    'use strict';
    angular.module('wamasysApp').config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        function definition(url, template, controller) {
            return {parent: 'app', url: url, data: {authorities: [], pageTitle: 'global.menu.notifications'},
                views: {'content@': {templateUrl: 'app/business/notifications/' + template, controller: controller, controllerAs: 'vm'}},
                resolve: {notificationSession: ['Principal', '$state', '$q', '$rootScope', 'LoginService', function (Principal, $state, $q, $rootScope, LoginService) {
                    return Principal.identity().then(function (account) {
                        if (!account || account.activated === false) {
                            // Le projet utilise une fenêtre de connexion, pas un état 'login'.
                            $rootScope.redirected = true;
                            $rootScope.previousStateName = $rootScope.toState.name;
                            $rootScope.previousStateNameParams = angular.copy($rootScope.toStateParams);
                            $state.go('accessdenied'); LoginService.open();
                            return $q.reject('AUTHENTICATION_REQUIRED');
                        }
                        return account;
                    });
                }]}};
        }
        $stateProvider.state('notifications', definition('/notifications', 'notifications.html', 'NotificationsController'))
            .state('notification-detail', definition('/notifications/{id:[0-9]+}', 'notification-detail.html', 'NotificationDetailController'));
    }
}());
